import React from "react";

import { faSearch } from "@fortawesome/pro-regular-svg-icons";

//components
import FilterButton from "../../../components/Button/templates/FilterButton";
import Input from "../../../components/Inputs/InputText";

// hooks
import usePageWidthBreakpoint from "../../../hooks/usePageWidthBreakpoint";

//css
import css from "./StandardToolbarActionRow.module.scss";

type StandardToolbarActionRowProps = {
	/**
	 * Number of active filters to be displayed as a badge on the filter button if its rendered.
	 * Expects a number.
	 */
	activeFiltersCount?: number;
	/**
	 * The function to be called when the filter button is pressed.
	 * Expects a function.
	 * If provided, a filter button will be rendered.
	 * If not provided, no filter button will be rendered.
	 */
	onFilterButtonPress?: () => void;

	/**
	 * The function to be called when the search input value changes.
	 * Expects a function.
	 * If provided, a search input will be rendered.
	 * If not provided, no search input will be rendered.
	 */
	onSearchInputChange?: (value: string) => void;
	/**
	 * The value of the search input.
	 * Expects a string.
	 */
	searchInput?: string;

	/**
	 * The placeholder of the search input.
	 * Expects a string.
	 */
	searchPlaceholder?: string;
};

const StandardToolbarActionRow = ({
	activeFiltersCount,
	onFilterButtonPress,
	onSearchInputChange,
	searchInput = "",
	searchPlaceholder = "Search ...",
}: StandardToolbarActionRowProps) => {
	const { isDesktop } = usePageWidthBreakpoint();

	return (
		<div className={css.standardToolbarActionRow}>
			{onSearchInputChange && (
				<Input
					className={`${css.searchInput} ${!isDesktop && css.mobile}`}
					icon={faSearch}
					value={searchInput}
					onChange={(value) => onSearchInputChange(value)}
					placeholder={searchPlaceholder}
					ariaLabel="Search"
					clearable
					testId="pageTemplateSearchInput"
				/>
			)}
			{onFilterButtonPress && <FilterButton numberOfFilters={activeFiltersCount} onClick={onFilterButtonPress} />}
		</div>
	);
};

export default StandardToolbarActionRow;
